<template>
  <div class="vl-pass">
    <div class="forgetPwdHead">
      <ul>
        <li :class="{ 'atPresent': active == index,'EXIST': index < active || active == stepList.length - 1}"
            v-for="(item, index) in stepList" :key="index">
          <i class="iconfont icon-nav_icon_Management_default" v-if="index == 0"></i>
          <i class="iconfont icon-nav_icon_set_default" v-if="index == 1"></i>
          <i class="iconfont icon-icon_finish_default" v-if="index == 2"></i>
          <p>{{item.name}}</p>
          <i class="iconfont icon-icon_arrow_default orientation" v-if="index != 2"></i>
        </li>

      </ul>
    </div>
    <div class="process novo">
      <h3>{{active == 0 ? "身份验证" : active == 1 ? "设置新密码" : "完成"}}</h3>
      <p v-if="active == 1" class="setting">
        您正在为<span>帐号{{formInline.mailbox.replace(formInline.mailbox.substring(3,
        formInline.mailbox.indexOf('@')), "****")}}</span>设置新密码</p>
      <el-form :model="formInline" ref="form" style="width: 65%;margin: 0 auto 0;" :rules="rules">
        <el-form-item v-if="active == 0" prop="mailbox">
          <el-input v-model="formInline.mailbox" auto-complete="on" placeholder="请输入邮箱地址"
                    maxlength="60">
            <span slot="suffix" class="blueFont" @click="sendCode">{{showSpan}}</span>
          </el-input>
        </el-form-item>
        <el-form-item v-if="active == 0" prop="verificationCode">
          <el-input class="dispose" v-model="formInline.verificationCode" auto-complete="on"
                    maxlength="4" placeholder="请输入验证码" style="width: 73%;"></el-input>
          <img :src="'data:image/jpg;base64,' + base64Img" alt="" width="126px" height="54px"
               style="float: right;" @click="getBase64Code">
        </el-form-item>
        <el-form-item v-if="active == 0" prop="mailboxCode">
          <el-input class="dispose" v-model="formInline.mailboxCode" auto-complete="on" maxlength="6"
                    placeholder="请输入邮箱验证码">

          </el-input>
        </el-form-item>

        <el-form-item v-if="active == 1" prop="newCipher">
          <el-input v-model="formInline.newCipher" auto-complete="on" maxlength="20" show-password
                    class="pwdInput" placeholder="请输入新密码">
          </el-input>
        </el-form-item>
        <el-form-item v-if="active == 1" prop="affirmCipher">
          <el-input v-model="formInline.affirmCipher" auto-complete="on" maxlength="20" show-password
                    class="pwdInput" placeholder="请确认密码"></el-input>
        </el-form-item>

        <div class="reset" v-if="active == 2">
          <i class="iconfont icon-icon_finish_default"></i>
          <p class="success">重置密码成功</p>
          <p class="back">{{backTime}}秒后自动返回登录页面</p>
        </div>

        <el-form-item>
          <el-button type="primary" v-if="active != 2" @click="next('form')">下一步</el-button>
          <el-button type="primary" v-else @click="toLogIn">立刻返回</el-button>
        </el-form-item>
        <el-form-item  v-if="active == 1" prop="mailboxCode">
          <div class="dealCont">
            设置密码说明：<br />
            1、长度为8-15个字符<br />
            2、至少包含大写字母、小写字母、数字、特殊字符的组合，特殊字符：!@#$%^&*￥……<br />
            3、不能出现3个或3个以上连续的数字或字母，如123，ABC,abc<br />
            4、不能出现3个或3个以上重复的数字或字母，如111，AAA,aaa<br />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import {
    CommonGetCaptcha,
    CommonPostCompanySendEmailCode,
    CommonPostCompanyActivateEmail,
    CommonPostCompanyForgetPwd
  } from '@/views/index/api/api.common.js';
  export default {
    data() {
      const affirm = (rule, code, callback) => {
        if (this.formInline.newCipher != code) {
          callback(new Error("密码输入不一致，请重新确认密码。"))
        } else {
          callback()
        }
      }
      return {
        backTime: 5,
        voluntarily: null,
        base64Img: '',
        info: {},
        showSpan: "发送验证码",
        isDis: false,
        time: 60,
        active: 0,
        stepList: [{
          name: "身份验证"
        }, {
          name: "设置新密码"
        }, {
          name: "完成"
        }],
        formInline: {
          mailbox: null,
          mailboxCode: null,
          newCipher: null,
          affirmCipher: null,
          verificationCode: null,
          uuid: null,
        },
        rules: {
          mailbox: [
            { required: true, message: "请输入邮箱地址", trigger: "blur" },
            {
              pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
              message: "请输入正确的邮箱地址",
              trigger: "blur"
            }
          ],
          mailboxCode: [
            { required: true, message: "请输入邮箱验证码", trigger: "blur" },
            {
              pattern: /^\d{6}$/,
              message: "请输入正确的验证码",
              trigger: "blur",
            },
          ],
          newCipher: [
            { required: true, message: "请输入新密码", trigger: "blur" },
            {
              pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&！@#￥%……&])[0-9a-zA-Z!@#$%^&！@#￥%……&]{8,15}$/,
              message: "要求长度8~15位，大写字母+小写字母+数字+特殊字符的组合",
              trigger: "blur",
            }
          ],
          affirmCipher: [
            { required: true, message: "请确认密码", trigger: "blur" },
            {
              validator: affirm, trigger: 'blur'
            }
          ],
          verificationCode: [
            { required: true, message: "请输入验证码", trigger: "blur" },
            // {
            //     pattern: /^\d{6}$/,
            //     message: "请输入正确的验证码",
            //     trigger: "blur",
            // },
          ],
        }
      }
    },
    mounted() {
      this.getBase64Code();
    },
    methods: {
      /**
       * 获取图片验证码
       * */
      getBase64Code() {
        CommonGetCaptcha().then(res => {
          if (res && res.result) {
            this.base64Img = res.result.img;
            this.formInline.uuid = res.result.uuid;
          }
        })
      },
      rsaEncrypt(data) {
      // 公钥
      let PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg8DC7bojdiFoqNjZHD+beD2sZnjwXJ17OyvpmRdxlTK2ABzWKm1ugid4Bo66z1IIu78t8JO7Fms92QR+J/w6ykIUzRGqsmp3j1e47boK0zuYgp5z/afQrL4F+G5NW3Wb2626mmM3G4WPho9M88E+v5j2y9wZTM7az1KomKKEvBwY2cROJFaYp04OSFJo9aee5ynGX66rgr1zStEPaz0jW0v4g7mrkEnu6p1EgW3Z8n7sieUqTYk+yn6lNf3lnb4e6QUAb1gpG0+9DiTDvAzePazjX3U7BTFOlMkBm6PFx+x+LTNUIrRn+2EBOYP2TKiZoDSOQS1jsuPcyOSYEhzzcQIDAQAB';
      // 使用公钥加密
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(PUBLIC_KEY)
      let result = encrypt.encrypt(data)
      return result
    },
    decrypt(msg) {
      const privateKey = ''
      let decrypt = new JSEncrypt()
      decrypt.setPrivateKey(privateKey)
      var decryptMsg = decrypt.decrypt(msg)
      return decryptMsg
    },

      /**
       * 处理下一步回调
       * */
      todoNext() {
        this.active += 1;
        if (this.active == 2) {
          this.voluntarily = setInterval(this.goBack, 1000);
        }
      },

      // 下一步
      next() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let obj = {};
            if (this.active == 0) {
              obj.captchaCode = this.formInline.verificationCode;
              obj.companyEmail = this.formInline.mailbox;
              obj.verificationCode = this.formInline.mailboxCode;
              obj.uuid = this.formInline.uuid;
              obj.type = "2";
              CommonPostCompanyActivateEmail(obj).then(res => {
                if (res) {
                  this.todoNext()
                } else {
                  if (this.active == 0) {
                    this.getBase64Code();
                  }
                }
              })
            } else if (this.active == 1) {
              obj.loginPwd = this.rsaEncrypt(this.formInline.newCipher);
              obj.companyEmail = this.formInline.mailbox;
              obj.verificationCode = this.formInline.mailboxCode;
              CommonPostCompanyForgetPwd(obj).then(res => {
                if (res) {
                  this.todoNext()
                } else {
                  if (this.active == 0) {
                    this.getBase64Code();
                  }
                }
              })
            }
          }
        });
      },
      // 发送邮箱验证码
      sendCode() {
        this.$refs["form"].validateField('mailbox', val => {
          if (!val) {
            if (!this.isDis) {
              let params = {
                companyEmail: this.formInline.mailbox,
                type: "2"
              }
              CommonPostCompanySendEmailCode(params).then(res => {
                if (res) {
                  this.time = 60;
                  this.timer()
                }
              })
            }

          }
        })

      },
      goBack() {
        this.backTime--;
        if (this.backTime == 0) {
          clearInterval(this.voluntarily);
          this.$router.push({name: 'index'})
        }
      },

      //发送验证码倒计时
      timer() {
        if (this.time > 0) {
          this.isDis = true;
          this.time--;
          this.showSpan = this.time + "秒";
          setTimeout(this.timer, 1000);
        } else {
          this.time = 0;
          this.showSpan = "发送验证码";
          this.isDis = false;
        }
      }
    },
  }
</script>
<style lang="scss">
  .vl-pass {
    width:1200px;
    margin:0 auto;
    background: #fff;
    margin-top: 20px;
    padding-bottom: 200px;
    .blueFont {
      color:#4286F5;
    }
    .forgetPwdHead {
      height: 145px;
    }
    .forgetPwdHead > ul {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #f4f4f4;
      margin-bottom: 36px;
    }
    .forgetPwdHead > ul > li {
      flex: 1;
      text-align: center;
      position: relative;
    }
    .forgetPwdHead > ul > li p {
      color: #333333;
      margin-top: 10px;
    }
    .forgetPwdHead > ul > li.atPresent i:first-child, .forgetPwdHead > ul > li.EXIST > i:first-child {
      background: #0ECAD6;
      border-radius: 50%;
      padding: 5px;
      color: #fff;
    }
    .forgetPwdHead > ul > li.atPresent p , .forgetPwdHead > ul > li.EXIST p {
      color: #0ECAD6;
    }
    .forgetPwdHead > ul > li .orientation {
      position: absolute;
      top: -45px;
      left: 80%;
      font-size: 120px;
      color: #0ECAD6;
    }
    .invariable {
      height: 200px;
      background: url(../../../assets/img/activeAccount/setting.png) no-repeat center;
      background-size: 100% 100%;
      position: relative;
    }
    .invariable > .stepTitle {
      font-size: 24px;
      color: #A7CCF2;
      font-weight: bold;
      position: absolute;
      top: 70px;
      left: 220px;
      line-height: 35px !important;
    }
    .invariable > .stepTitle > span:first-child {
      color: #3F7BBB;
    }
    .dealCont {
      line-height: 20px;
      font-family: 'Arial Normal', 'Arial', sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      letter-spacing: normal;
      color: #333333;
    }
    .accomplish {
      text-align: center;
      margin-bottom: 30px;
    }
    .accomplish > img {
      margin-top: 60px;
      display: inline-block;
    }
    .accomplish > p {
      padding-top: 20px;
      font-size: 24px;
      font-weight: bold;
      color: #4286F5;
    }
    .reset {
      text-align: center;
      margin-top: 30px;
    }
    .reset > i {
      padding: 20px;
      border: 1px solid #4286F5;
      border-radius: 50%;
      color: #4286F5;
    }
    .reset > .success {
      font-size: 18px;
      color: #333;
      padding: 40px 0;
    }
    .reset > .back {
      color: #999;
      padding-bottom: 20px;
    }
    .el-form-item {
      margin-bottom: 18px !important;
    }
    .el-form-item:last-child {
      /* margin-bottom: 200px !important; */
    }
    .process > h3 {
      font-size: 24px;
      color: #0ECAD6;
      text-align: center;
      padding-bottom: 30px;
    }
    .process > .setting {
      text-align: center;
      color: #999999;
      margin-bottom: 20px;
    }
    .process > .setting > span {
      color: #333;
    }
    .process {
      width: 800px;
      margin: 0 auto;
    }
    .process > ul {
      display: flex;
      background: #F1F7FF;
    }
    .process > ul > li {
      flex: 1;
      padding: 17px 0;
      text-align: center;
      font-size: 18px;
      color: #999999;
    }
    .process > ul > li.atPresent {
      background: url(../../../assets/img/activeAccount/articleSteps.png) no-repeat center;
      background-size: 100% 100%;
      color: #4286F5;
    }

    .process > ul > li > i {
      display: inline-block;
      width: 26px;
      height: 26px;
      border: 1px solid #999999;
      border-radius: 50%;
      margin-right: 5px;
    }
    .process > ul > li.atPresent > i, .process > ul > li.EXIST > i {
      background: #4286F5;
      border: 1px solid #4286F5;
      color: #fff;
    }
    .process > ul > li.EXIST {
      color: #4286F5;
      background-color: #E4F1FF;
    }

    .process .el-button--primary {
      font-size: 14px;
      padding: 12px 24px !important;
    }
    .process .el-input__suffix {
      top: 8px !important;
      right: 15px !important;
    }
    .process .el-input__suffix .el-input__suffix-inner {
      border-left: 1px solid #DCDFE6;
      padding-left: 15px !important;
      cursor: pointer;
    }
    .novo {
      margin-top: 36px;
    }
    .novo .el-input__inner {
      height: 54px !important;
      line-height: 54px !important;
      border: 1px solid #ECECEC !important;
    }
    .novo .el-button {
      width: 100%;
      padding: 18px 0 !important;
      font-size: 16px !important;
    }
    .novo .el-form-item__content {
      line-height: 54px !important;
    }
    .novo .el-input__suffix {
      top: 0 !important;
    }
  }
</style>